import { defineComponent as _defineComponent } from 'vue';
import { BInputGroup } from "bootstrap-vue";
import { computed, ref, watch } from "vue";
import {} from "@/utils/filtering";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterMenuMultiTags',
    props: {
        name: null,
        identifier: null,
        filter: null,
        filters: null
    },
    emits: ["change"],
    setup(__props, { emit }) {
        const props = __props;
        const propValue = computed(() => props.filters[props.name]);
        const localValue = ref(propValue.value);
        watch(() => localValue.value, (newFilter) => {
            emit("change", props.name, newFilter);
        });
        watch(() => propValue.value, (newFilter) => {
            localValue.value = newFilter;
        });
        return { __sfc: true, props, emit, propValue, localValue, BInputGroup, StatelessTags };
    }
});
